enum CashFlowTablesEnum {
  ACCOUNTS_PAYABLE = 'accounts_payable',
  ACCOUNTS_RECEIVABLE = 'accounts_receivable',
  BANKS = 'banks',
}

export default CashFlowTablesEnum;
